import { useEffect, useRef } from "react";

const CustomCursor = () => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const move = (e) => {
      el.style.transform = `translate(${e.clientX}px, ${e.clientY}px) translate(-50%, -50%)`;
    };

    const onOver = (e) => {
      const t = e.target;
      if (t.closest("a, button, [data-cursor='hover'], input, textarea")) {
        el.classList.add("hovering");
      }
    };
    const onOut = (e) => {
      const t = e.target;
      if (t.closest("a, button, [data-cursor='hover'], input, textarea")) {
        el.classList.remove("hovering");
      }
    };

    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", onOver);
    window.addEventListener("mouseout", onOut);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", onOver);
      window.removeEventListener("mouseout", onOut);
    };
  }, []);

  return <div ref={ref} className="vc-cursor" data-testid="custom-cursor" aria-hidden="true" />;
};

export default CustomCursor;
